import { Card } from "@verde/compose-ui";
import {
  type FetchClient,
  type FetchClientCreditsUsage,
  useFetchCreditUsageRating,
} from "@verde/entities";
import { Skeleton } from "@verde/ui-core";
import { formatDate } from "@verde/utils";
import { CreditProfile } from "modules/credit-profile";
import { useMemo } from "react";

interface CreditProfileTabProps {
  client?: FetchClient;
  creditUsage?: FetchClientCreditsUsage;
}

export default function CreditProfileTab({
  client,
  creditUsage,
}: CreditProfileTabProps) {
  const { data, isLoading } = useFetchCreditUsageRating(creditUsage?.id);

  const updating = useMemo(() => {
    return !!creditUsage?.updating;
  }, [creditUsage]);

  return (
    <Card
      title="Perfil de Crédito - Verde"
      action={{
        render: (
          <p className="text-sm font-semibold text-neutral-dark-3">
            Rating atualizado em {formatDate(data?.report?.created_at)}
          </p>
        ),
      }}
    >
      <hr className="bg-neutral-light-2" />

      {isLoading ? (
        <Skeleton height={180} />
      ) : (
        <CreditProfile.Rating
          rating={data}
          client={client}
          updating={updating}
          creditUsageId={creditUsage?.id}
        />
      )}

      <CreditProfile.Capacity
        client={client}
        updating={updating}
        creditUsageId={creditUsage?.id}
      />
    </Card>
  );
}
